(function () {
  function initRechargeA11y(container) {
    const button = container.querySelector('button');
    if (!button || button.dataset.rcA11y) return;
    button.dataset.rcA11y = 'true';

    // .rc_popup__block is always in the DOM but shown only via CSS :hover on
    // the parent .rc_popup__hover div — keyboard/SR users never trigger :hover,
    // so we force it open/closed via inline style on click.
    const popupBlock = container.querySelector('.rc_popup__block');

    button.setAttribute('aria-expanded', 'false');

    function open() {
      button.setAttribute('aria-expanded', 'true');
      if (popupBlock) popupBlock.style.display = 'block';
    }

    function close() {
      button.setAttribute('aria-expanded', 'false');
      if (popupBlock) popupBlock.style.display = '';
    }

    button.addEventListener('click', () => {
      button.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) close();
    });
  }

  function patchAll() {
    document.querySelectorAll('form.shopify-product-form .rc-container-wrapper').forEach(initRechargeA11y);
  }

  const domObserver = new MutationObserver(patchAll);
  domObserver.observe(document.body, { childList: true, subtree: true });

  patchAll();
})();
